import styled, { css } from 'styled-components';
import { Button as BaseButton } from 'antd';
import { lighten, transparentize } from 'polished';
import type { IProps } from './index';

export const StyledButton = styled(BaseButton)<IProps>`
    && {
        ${({ theme, variant }) => css`
            font-size: ${theme.fontSizes.default};
            width: 100%;
            border-radius: 8px;
            ${() => {
                switch (variant) {
                    case 'danger':
                        return css`
                            background-color: ${theme.colors.fail};
                            border: ${theme.colors.fail};
                            &:hover {
                                background-color: ${lighten(
                                    0.2,
                                    theme.colors.fail,
                                )};
                            }
                        `;
                    case 'default':
                        return css`
                            background-color: ${theme.colors.accentColor};
                            border: ${theme.colors.accentColor};
                            &:hover {
                                background-color: ${lighten(
                                    0.1,
                                    theme.colors.accentColor,
                                )};
                            }
                        `;
                    case 'outline':
                        return css`
                            background-color: ${transparentize(
                                1,
                                theme.colors.accentColor,
                            )};
                            border: 1px solid ${theme.colors.accentColor};
                            color: ${theme.colors.accentColor};

                            &:hover {
                                background-color: ${theme.colors.accentColor};
                                color: ${theme.colors.white};
                            }
                        `;
                    case 'outline-danger':
                        return css`
                            background-color: ${transparentize(
                                1,
                                theme.colors.fail,
                            )};
                            border: 1px solid ${theme.colors.fail};
                            color: ${theme.colors.fail};

                            &:hover {
                                background-color: ${theme.colors.fail};
                                color: ${theme.colors.white};
                            }
                        `;
                    case 'success':
                        return css`
                            background-color: ${theme.colors.green};
                            border: ${theme.colors.green};
                            &:hover {
                                background-color: ${lighten(
                                    0.1,
                                    theme.colors.translucentGreen,
                                )};
                            }
                        `;
                    default:
                        return css``;
                }
            }};
        `}
    }
`;
